import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Tag } from "capitalrx-components-2.0/lib/general";

import { useIsParticipatingInMedicarePrescriptionPlan, useMedicarePrescriptionPaymentPlanGracePeriod } from "@/App/hooks";

export const GracePeriodStatus: FC<{planYear: number}> = ({ planYear }) => {
  const { t: translate } = useTranslation();
  const { isInGracePeriod } = useMedicarePrescriptionPaymentPlanGracePeriod(planYear);
  const { isParticipating } = useIsParticipatingInMedicarePrescriptionPlan(planYear);

  return (
    isParticipating
    && isInGracePeriod && (
      <p>
        <Tag testId="grace-period" type="warning-high-contrast">{translate("GRACE_PERIOD_STATUS.gracePeriod")}</Tag>
      </p>
    )
  );
};
